{
  "app.title": "Craft-Imperium",
  "app.tagline": "Herrsche klar. Handle präzise.",
  "common.loading": "Wird geladen …",
  "common.retry": "Erneut versuchen",
  "common.save": "Speichern",
  "common.cancel": "Abbrechen",
  "common.send": "Senden",
  "common.search": "Suchen",
  "common.back": "Zurück",
  "common.next": "Weiter",
  "common.previous": "Zurück",
  "common.none": "Keine",
  "common.unknown": "Unbekannt",
  "common.available": "Verfügbar",
  "common.unavailable": "Nicht verfügbar",
  "common.coordinates": "Koordinaten",
  "common.points": "Punkte",
  "common.revision": "Revision",
  "common.details": "Details",
  "common.simple": "Einfach",
  "common.expert": "Experte",
  "common.open": "Öffnen",
  "common.close": "Schließen",
  "common.refresh": "Aktualisieren",
  "common.filter": "Filter",
  "common.all": "Alle",
  "common.enabled": "Aktiv",
  "common.disabled": "Aus",
  "common.quantity": "Anzahl",
  "common.status": "Status",
  "common.world": "Welt",
  "common.village": "Dorf",
  "common.error": "Fehler",
  "common.empty": "Hier gibt es noch nichts zu zeigen.",
  "auth.login": "Anmelden",
  "auth.loginName": "Login oder E-Mail",
  "auth.password": "Passwort",
  "auth.totp": "2FA-Code (optional)",
  "auth.signOut": "Abmelden",
  "auth.sessionExpired": "Die Sitzung ist abgelaufen. Bitte erneut anmelden.",
  "auth.rememberMe": "Eingeloggt bleiben",
  "auth.rememberLogin": "Benutzername merken",
  "auth.passwordManagerHint": "Dein Passwort kann vom Passwortmanager deines Browsers gespeichert werden; Craft-Imperium speichert es nicht selbst.",
  "auth.register": "Registrieren",
  "auth.registerTitle": "Account erstellen",
  "auth.username": "Benutzername",
  "auth.email": "E-Mail-Adresse",
  "auth.passwordConfirmation": "Passwort bestätigen",
  "auth.createAccount": "Account erstellen",
  "auth.minimumAge": "Ich bestätige, dass ich das erforderliche Mindestalter erreicht habe.",
  "auth.acceptTerms": "Ich akzeptiere die aktuell gültigen Nutzungsbedingungen.",
  "auth.acceptPrivacy": "Ich akzeptiere die aktuell gültige Datenschutzerklärung.",
  "auth.registrationCreated": "Account erstellt. Bitte bestätige deine E-Mail-Adresse über den zugesandten Link.",
  "auth.registerConflict": "Benutzername oder E-Mail-Adresse ist bereits vergeben.",
  "auth.passwordRequirements": "Mindestens 12 Zeichen; bekannte kompromittierte Standardpasswörter werden abgelehnt.",
  "auth.legalOutdated": "Die rechtlichen Bedingungen wurden aktualisiert. Bitte öffne die Registrierung erneut.",
  "auth.legalRequired": "Bitte bestätige Mindestalter, Nutzungsbedingungen und Datenschutz.",
  "auth.tokenInvalid": "Der Link ist ungültig oder abgelaufen.",
  "auth.validationFailed": "Bitte prüfe deine Eingaben.",
  "auth.rateLimited": "Zu viele Versuche. Bitte versuche es später erneut.",
  "auth.verificationComplete": "E-Mail-Adresse erfolgreich bestätigt. Du kannst dich jetzt anmelden.",
  "auth.emailVerificationRequired": "Bitte bestätige zuerst deine E-Mail-Adresse, bevor du einer Welt beitrittst.",
  "auth.resendVerification": "Bestätigungslink erneut senden",
  "auth.verificationResent": "Ein neuer Bestätigungslink wurde angefordert.",
  "worlds.title": "Welten",
  "worlds.joined": "Beigetreten",
  "worlds.open": "Registrierung offen",
  "worlds.pending": "Spawn wird vorbereitet",
  "worlds.noVillage": "Noch kein eigenes Dorf verfügbar.",
  "nav.dashboard": "Übersicht",
  "nav.map": "Karte",
  "nav.buildings": "Gebäude",
  "nav.army": "Armee",
  "nav.research": "Forschung",
  "nav.smithy": "Schmiede",
  "nav.market": "Markt",
  "nav.reports": "Berichte",
  "nav.messages": "Nachrichten",
  "nav.alliance": "Allianz",
  "nav.quests": "Aufgaben",
  "nav.notifications": "Meldungen",
  "nav.settings": "Einstellungen",
  "nav.admin": "Profil-Editor",
  "nav.more": "Mehr",
  "nav.worlds": "Welten",
  "connection.online": "Online",
  "connection.reconnecting": "Verbindung wird wiederhergestellt …",
  "connection.offline": "Offline – Befehle sind gesperrt",
  "village.switch": "Dorf wechseln",
  "village.search": "Dörfer durchsuchen",
  "village.group": "Gruppe",
  "village.noMatch": "Kein passendes Dorf.",
  "resources.title": "Ressourcen",
  "resources.capacity": "Kapazität",
  "resources.rate": "Produktion/s",
  "resources.lost": "Verlorene Produktion",
  "dashboard.title": "Dorfübersicht",
  "dashboard.population": "Bevölkerung",
  "dashboard.profile": "Regelprofil",
  "dashboard.quick": "Schnellzugriff",
  "dashboard.slowHint": "Daten werden einzeln nachgeladen; Befehle bleiben bis zur Bestätigung unverändert.",
  "buildings.title": "Gebäude",
  "buildings.built": "Gebaut",
  "buildings.notBuilt": "Nicht gebaut",
  "buildings.level": "Stufe",
  "buildings.queue": "Bauwarteschlange",
  "army.title": "Armee",
  "army.total": "Gesamt",
  "army.reserved": "Reserviert",
  "army.attack": "Angriff planen",
  "research.title": "Forschung",
  "smithy.title": "Schmiede",
  "market.title": "Markt",
  "alliance.title": "Allianz",
  "quests.title": "Aufgaben & Ereignisse",
  "feature.serverDriven": "Diese Ansicht verwendet ausschließlich freigegebene Serverdaten. Nicht verfügbare Mechaniken werden nicht lokal nachgebildet.",
  "feature.unavailableTitle": "Funktion in dieser Welt nicht verfügbar",
  "feature.unavailableText": "Das aktive Regelprofil schaltet diese Funktion nicht frei. Es wurden keine verborgenen Daten geladen.",
  "map.title": "Weltkarte",
  "map.panUp": "Nach oben",
  "map.panDown": "Nach unten",
  "map.panLeft": "Nach links",
  "map.panRight": "Nach rechts",
  "map.selected": "Auswahl",
  "map.tapHint": "Antippen wählt nur aus. Ein Karten-Tap löst niemals einen Spielbefehl aus.",
  "map.empty": "In diesem Kartenausschnitt sind keine sichtbaren Objekte.",
  "attack.title": "Angriff planen",
  "attack.targetX": "Ziel X",
  "attack.targetY": "Ziel Y",
  "attack.preview": "Entwurf prüfen",
  "attack.confirm": "Angriff senden",
  "attack.draftOnly": "Ein Entwurf ist kein Angriff. Erst die finale Bestätigung sendet einen Befehl.",
  "attack.offline": "Offline kann kein Angriff gesendet werden.",
  "attack.sent": "Angriff wurde vom Server angenommen.",
  "reports.title": "Berichtszentrale",
  "reports.search": "Berichte durchsuchen",
  "reports.favorite": "Favorit",
  "reports.archived": "Archiviert",
  "reports.calculator": "Im Kampf-Rechner öffnen",
  "reports.privacy": "Freigaben enthalten ausschließlich die vom Server erlaubten Feldgruppen.",
  "messages.title": "Nachrichten",
  "messages.compose": "Nachricht verfassen",
  "messages.recipient": "Empfänger-Konto-ID",
  "messages.subject": "Betreff",
  "messages.body": "Nachricht",
  "messages.shortcutHint": "Tastenkürzel sind beim Schreiben und während IME-Eingabe deaktiviert.",
  "notifications.title": "Meldungen",
  "settings.title": "Einstellungen",
  "settings.language": "Sprache",
  "settings.theme": "Darstellung",
  "settings.themeSystem": "System",
  "settings.themeLight": "Hell",
  "settings.themeDark": "Dunkel",
  "settings.navMode": "Desktop-Navigation",
  "settings.navIconsText": "Symbole + Text",
  "settings.navIconsOnly": "Nur Symbole",
  "settings.navTextOnly": "Nur Text",
  "settings.navCollapsed": "Eingeklappt",
  "settings.detailed": "Detailansichten",
  "settings.reducedMotion": "Bewegungen reduzieren",
  "settings.shortcuts": "Tastenkürzel",
  "settings.tips": "Hinweise",
  "settings.volume": "Lautstärke",
  "settings.shortcutsList": "M Karte · R Berichte · D Übersicht · A Armee",
  "settings.pwa": "App-Installation",
  "settings.install": "App installieren",
  "settings.installed": "Als App installiert",
  "settings.notInstallable": "Installation wird vom Browser derzeit nicht angeboten.",
  "settings.offlinePolicy": "Offline werden nur App-Shell und statische Assets bereitgestellt. API-Antworten und Spielbefehle werden nicht aus einem Service-Worker-Cache simuliert.",
  "admin.title": "Regelprofil-Editor",
  "admin.draftId": "Draft-ID",
  "admin.load": "Draft laden",
  "admin.metadata": "Metadaten",
  "admin.expertJson": "Kanonischer Profilinhalt (JSON)",
  "admin.sameDraft": "Simple und Expert bearbeiten denselben kanonischen Draft; es existiert keine zweite Regel-Engine im Client.",
  "admin.validate": "Validieren",
  "admin.valid": "Draft ist valide.",
  "admin.saved": "Draft gespeichert.",
  "errors.offlineCommand": "Der Befehl wurde nicht gesendet, weil die Verbindung offline ist.",
  "errors.load": "Daten konnten nicht geladen werden.",
  "errors.notFound": "Seite nicht gefunden",
  "errors.forbidden": "Für diese Ansicht fehlt die Berechtigung.",
  "a11y.skip": "Zum Inhalt springen",
  "army.unit": "Einheit",
  "attack.targetVillageId": "Zieldorf-ID",
  "attack.target": "Ziel",
  "reports.calculatorDraft": "Kampfrechner-Entwurf",
  "reports.unknownStaysUnknown": "Unbekannte Werte bleiben unbekannt.",
  "map.chunk": "Kartenausschnitt",
  "map.panControls": "Kartensteuerung",
  "map.visibleObjects": "Sichtbare Kartenobjekte",
  "a11y.primaryNavigation": "Hauptnavigation",
  "resources.wood": "Holz",
  "resources.clay": "Lehm",
  "resources.iron": "Eisen",
  "dashboard.populationFree": "frei",
  "army.trainingQueue": "Ausbildungswarteschlange",
  "buildings.build": "Bauen",
  "buildings.upgrade": "Ausbauen",
  "buildings.maxLevel": "Maximalstufe",
  "buildings.noMore": "Dieses Regelprofil enthält keine weiteren baubaren Gebäude.",
  "buildings.queueEmpty": "Keine Bauaufträge aktiv.",
  "building.headquarters": "Hauptgebäude",
  "building.woodcutter": "Holzfäller",
  "building.quarry": "Lehmgrube",
  "building.clayPit": "Lehmgrube",
  "building.ironMine": "Eisenmine",
  "building.warehouse": "Speicher",
  "map.home": "Zum eigenen Dorf",
  "errors.command": "Der Befehl wurde nicht angenommen. Bitte aktualisieren und erneut versuchen.",
  "reports.select": "Wähle links einen Bericht aus, um Details zu sehen."
}
